module.exports = __webpack_public_path__ + "img/tomato.be5030ca.webp";